import React from 'react';
import AwardCard from '../about/AwardCard';
import { awardsContainer, headingStyle } from './ProjectAwards.module.scss';

const ProjectAwards = ({ awards }) => {
  return (
    <div className={`gridCenterContent`}>
      <h3 className={`${headingStyle}`}>Awards</h3>
      <div className={`${awardsContainer}`}>
        {awards.map(({ name, category, year, color }, index) => (
          <AwardCard
            name={name}
            category={category}
            year={year}
            work={''}
            key={index}
            color={color}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectAwards;
